import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { User } from "../../../../types/types/user.types";

import { getUserProfile } from "../services/profile.service";
import { userKeys } from "../queryKeys";

export const useUserProfile = (userId: string | null) => {
  const { i18n } = useTranslation();

  return useQuery<User, Error>({
    queryKey: [...userKeys.profile(userId!), i18n.language],
    queryFn: async () => {
      const response = await getUserProfile(userId!);
      return response.data;
    },
    enabled: !!userId,
  });
};
